import { TextField } from "@material-ui/core";
import React from "react";

type TextFieldMultiOutlinedProps = {
  id: string;
  label: string;
  rows: number;
  inputProps?: any;
  name?: string;
  defaultValue?: string;
  value?: string;
  onChange?: (value: string) => void;
};

const TextFieldMultiOutlined = ({
  id,
  label,
  name,
  rows,
  inputProps,
  value,
  onChange,
}: TextFieldMultiOutlinedProps) => {
  return (
    <TextField
      style={{ width: "100%" }}
      id={id}
      label={label}
      type="text"
      multiline
      minRows={rows}
      inputProps={inputProps}
      name={name}
      value={value}
      variant="outlined"
      disabled={onChange === undefined}
      onChange={(e) => {
        if (onChange) onChange(e.target.value);
      }}
    />
  );
};

export default TextFieldMultiOutlined;
